var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{attrs:{"icon":"","color":"error","small":"","loading":_vm.loading},on:{"click":_vm.remove}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-delete")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }